<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
    <div class="text-center">
      <div class="flex items-center justify-center mb-8">
        <svg class="w-16 h-16 text-red-500 mr-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
        </svg>
        <h1 class="text-6xl font-bold text-red-500">{{ t('unauthorized.code') }}</h1>
      </div>
      <h2 class="text-3xl font-semibold text-red-500 mb-4">{{ t('unauthorized.title') }}</h2>
      <p class="text-gray-600 dark:text-gray-400 text-lg mb-8">{{ t('unauthorized.message') }}</p>
      <button @click="$router.push('/')" class="btn bg-red-500 hover:bg-red-600 text-white px-8 py-3 rounded-lg transition-colors duration-200">
        {{ t('unauthorized.returnHome') }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from '@/i18n';

const { t } = useI18n();
</script> 
